import React, { Component } from "react";
import { withRouter } from "react-router";
import Dropzone from 'react-dropzone'
import withReactContent from "sweetalert2-react-content";
import { Toast } from "../../utils/sweetalert";
import * as  XLSX from 'xlsx';
import dataJson from '../../i18n/locales/es/translations.json'
import dataJsonEn from '../../i18n/locales/en/translations.json'


import {
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Label
} from "reactstrap";


class Forms extends Component {
  constructor(props) {
    super(props) 
    this.state = {
      file : {
        name: ''
      },
      jsonExcel : [],
      arrayImgFile : [],
      arrayImgname: [],
      disabled: false
    }
  }
  handleSubmit = async (e) =>{
    e.preventDefault()
    const MySwal = withReactContent(Toast)
    if(this.state.jsonExcel.length ===0 ) {
      await MySwal.fire({
        title: <p style={{fontSize: '15px'}}>Introduzca los archivos</p>,
        icon: 'error',
        
    })
    return
    }
    this.setState({disabled: true})
   for(const {data, sheetName} of this.state.jsonExcel) {
    var count = 0
    //console.log(sheetName)
    const objEs ={}
    const objEng ={}
    //aqui recorremos cada columna de las paginas
    for(const activitie of data) {
      objEs[`ss${count}${activitie.key}`] = activitie.content
      objEng[`ss${count}${activitie.key}`] = activitie.traduccionEng
      count++
    }
    //console.log(array)
    var jsonEs = JSON.stringify(objEs);
    var jsonEn = JSON.stringify(objEng);
    debugger
    try {
      //console.log(jsonEs)
      //console.log(jsonEn)
    } catch (error) {
      //console.log(error)
    }
  }
  
  this.setState({disabled: false})

  }
  handleFile = (acceptedFiles) => {
    const noXLSX= acceptedFiles.find((e) => {
      return e.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    if(noXLSX) return
    this.setState({files: acceptedFiles[0]})
    debugger
    let hojas = []
    let reader = new FileReader()
    reader.readAsArrayBuffer(acceptedFiles[0])
    reader.onloadend= (e) => {
      var data = new Uint8Array(e.target.result)
      var workbook = XLSX.read(data, {type: 'array'})

      workbook.SheetNames.forEach(function (sheetName) {
        var XL_row_obj = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName])
        hojas.push({
          data: XL_row_obj,
          sheetName
        })
      })
      //console.log(hojas)
      this.setState({
        file: acceptedFiles[0],
        jsonExcel: hojas
      })
    }
  }
  handleImg = (acceptedFiles) => {
    const namesImg = []
    const noXLSX= acceptedFiles.find((e) => {
      namesImg.push(e.name)
      return !e.type.includes('image/')
    })
    debugger
    if(noXLSX) return
    this.setState({arrayImgFile: acceptedFiles,arrayImgname: namesImg })
  }
  prueba =() =>{
    debugger
    const array =[
    ]
    for( const element in dataJson ) {
      array.push({
        key: element, content: dataJson[element],contentEnglish:dataJsonEn[element]
      })
    }
    let data = XLSX.utils.json_to_sheet(array);
    const workbook = XLSX.utils.book_new();
    const filename = "planilla";
    XLSX.utils.book_append_sheet(workbook, data, filename);
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  }
  render() {
    return (
      <>
      <div className="content">
        <Row>
          <Col md="12">
          <Card>
          <CardHeader>
          <CardTitle tag="h4">Procesar Excel</CardTitle>
          </CardHeader>
      <CardBody>
        <form onSubmit={this.handleSubmit}>
          <Row>
                    <Col className="pl-md-1" md="12">
                    <Label >Introduzca el archivo Xlsx</Label>
                    <Dropzone onDrop={this.handleFile}>
                      {({getRootProps, getInputProps}) => (
                        <section>
                          <div  className='dropZoneCont' {...getRootProps()}>
                            <input accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' {...getInputProps()} />
                            <p>{!this.state.file.name ? "Drag 'n' drop some files here, or click to select files" : this.state.file.name}</p>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                    </Col>
                    
                  </Row>
          
          
          <Button disabled={this.state.disabled} color="primary" type="submit">
            Cargar Datos
          </Button>
          <Button onClick={this.prueba.bind(this)} color="primary" type="button">
            exportar json de traducciones
          </Button>
        </form>
      </CardBody>
    </Card>
          </Col>
        </Row>
      </div>
    </>
    )
  }
}


export default withRouter(Forms);


/*   debugger
    let workbook = XLSX.utils.book_new();
    const filename = "planillaPrueba";
   for(const {data, sheetName} of this.state.jsonExcel) {
    var count = 0
    //console.log(sheetName)
    const array =[]
    //aqui recorremos cada columna de las paginas
    for(const activitie of data) {
esta funcion es para el actualizar el viejo modelo con el nuevo
      const obj ={
        '1name': activitie?.name || '',
        '2nameEn':'',
        '3title': activitie?.name || '',
        '4titleEn':'',
        '5lat': activitie?.lat || 0,
        '6lon': activitie?.lon || 0,
        '7stars': activitie?.stars || '',
        '8duration': activitie?.duration || 0,
        '9urlImg': activitie?.urlImg || '',
        '10color': activitie?.color || '',
        '11location': activitie?.location || '',
        '12country': activitie?.country || '',
        '13web': activitie?.web || '',
        '14mail': activitie?.mail || '',
        '15tlf': activitie?.tlf || '',
        '16description': 
        `${activitie?.phrase}
        ${activitie?.descriptionShort}
        ${activitie?.descriptionLarge}`,
        '17descriptionEn':'',
        '18horarios': activitie?.horarios || '',
        '19rangoDias': activitie?.rangoDias || '',
        '20horas': activitie?.horas || 0,
        '21moneda': activitie?.moneda || '',
        '22namestickets': activitie?.namestickets || '',
        '23namesticktesEn': '',
        '24precios': `${activitie?.precios}` || ''
      }
      try {
        obj['24precios']=obj['24precios'].replaceAll('gratis', '0')
        obj['24precios']=obj['24precios'].replaceAll('gratuito', '0')
        obj['24precios']=obj['24precios'].replaceAll('free', '0')
        obj['24precios']=obj['24precios'].replaceAll('gratuita', '0')
        
      } catch (error) {
        //console.log(error,obj)
        debugger
      }
      array.push(obj)
    }
    //console.log(array)
    let dataExcel = XLSX.utils.json_to_sheet(array);
    
    XLSX.utils.book_append_sheet(workbook, dataExcel, sheetName);
  }
  try {
    XLSX.writeFile(workbook, `preuba.xlsx`);
  } catch (error) {
    //console.log(error)
  }
  */